/** Approximate bounding boxes for each built-in element, in 1080-space.
 *
 *  These are visual handles only — the real rendering is server-side. They live
 *  here rather than in Canvas because the lifestyle clamp (lib/lifestyleLayout)
 *  needs the same numbers: if the two disagreed, the editor would clamp an
 *  element to a position its own drag handle then refuses to sit at.
 */
export const ELEMENT_BOXES: Record<string, { w: number; h: number; color: string }> = {
  rating: { w: 200, h: 90, color: 'var(--ff-blue)' },
  deal: { w: 200, h: 100, color: 'var(--ff-orange)' },
  price_card: { w: 360, h: 160, color: 'var(--ff-ink-soft)' },
  logo: { w: 200, h: 90, color: 'var(--ff-ink)' },
  disclaimer: { w: 960, h: 50, color: 'var(--ff-mute)' },
};

/** Built-in elements the operator can hide. `product_image` is deliberately
 *  absent: an ad without its product is never wanted, so it has position and
 *  scale but no visibility toggle (see compositor._compose_product). */
export const HIDEABLE_KEYS = Object.keys(ELEMENT_BOXES);

/** Approximate box for a custom text/field overlay, mirroring Canvas's math. */
export function customElementBox(el: {
  type?: string;
  value?: string;
  field?: string;
  font_size?: number;
}): { w: number; h: number } {
  const charW = (el.font_size ?? 28) * 0.6;
  const label = el.type === 'text' ? (el.value ?? '') : `:${el.field ?? ''}`;
  return {
    w: Math.max(120, charW * Math.max(4, label.length)),
    h: Math.max(60, Math.round((el.font_size ?? 28) * 1.7)),
  };
}
